import { Injectable } from '@angular/core';

import { BehaviorSubject, filter, map, of, switchMap, take } from 'rxjs';

import { SocketImpl } from '@common/types/socket-impl';
import { SOCKET_BANK_ID_GLOBAL } from '@common/util/constants';

@Injectable({
  providedIn: 'root',
})
export class SocketBankService {
  constructor() {}

  private socketBank: Record<string, SocketImpl> = {};

  private globalSocketSubject = new BehaviorSubject<SocketImpl | null>(null);
  globalSocket$ = this.globalSocketSubject.asObservable().pipe(
    filter((socket) => !!socket),
    switchMap((socket) => {
      if (socket.isConnected()) {
        return of(socket);
      }

      return socket.connectionStatus$.pipe(
        filter((connected) => connected),
        take(1),
        map(() => socket),
      );
    }),
  );

  setSocket(id: string, socket: SocketImpl) {
    this.socketBank[id] = socket;

    if (id === SOCKET_BANK_ID_GLOBAL) {
      this.globalSocketSubject.next(socket);
    }
  }

  getSocket(id: string) {
    return this.socketBank[id];
  }

  removeSocket(id: string) {
    delete this.socketBank[id];
  }
}
